import { UserProfile } from '@shared/types/profile.types';

export interface AuthDetails {
  provider: 'email' | 'google';
  hasPassword: boolean;
  lastPasswordChange?: string;
}

export interface UpdateProfileDto {
  profile?: UserProfile;
  settings?: UserSettings;
}

export interface UpdatePasswordDto {
  currentPassword: string;
  newPassword: string;
}

export interface User {
  id: string;
  uid: string;
  email: string;
  imageUrl: string;
  role: number;
  profile: UserProfile;
  settings: UserSettings;
  status: string;
  deleted: boolean;
  authDetails: AuthDetails;
}

export interface NotificationSettings {
  comments: boolean;
  messages: boolean;
  mentions: boolean;
  likePosts: boolean;
  connections: boolean;
}

export interface UserSettings {
  notificationSettings: NotificationSettings;
  language: string;
  theme: string;
}

/**
 * Base user roles for the application
 */
export enum UserRole {
  ADMIN = 0,
  STUDENT = 1,
}